import { type PropsWithChildren } from 'react';

import { joinCn } from '../util';
import type { VFlexProps } from './type';

const VFlex = ({
  children,
  ref,
  direction,
  items,
  justify,
  gap,
  wrap,
  className,
  style,
  ...rest
}: PropsWithChildren<VFlexProps> &
  React.HTMLProps<HTMLDivElement> &
  React.RefAttributes<HTMLDivElement>) => {
  return (
    <div
      ref={ref}
      className={joinCn(
        {
          flex: true,
          'flex-col': direction === 'col',

          'items-center': items === 'center',
          'items-start': items === 'start',
          'items-end': items === 'end',
          'items-stretch': items === 'stretch',
          'items-baseline': items === 'baseline',

          'justify-center': justify === 'center',
          'justify-start': justify === 'start',
          'justify-end': justify === 'end',
          'justify-stretch': justify === 'stretch',
          'justify-between': justify === 'between',
          'justify-around': justify === 'around',
          'justify-evenly': justify === 'evenly',

          'flex-wrap': wrap === 'wrap',
          'flex-nowrap': wrap === 'nowrap',
          'flex-wrap-reverse': wrap === 'wrap-reverse',
        },
        className,
      )}
      style={{
        ...style,
        gap: gap != null ? `${+gap * 16}px` : '',
      }}
      {...rest}
    >
      {children}
    </div>
  );
};

VFlex.displayName = 'VFlex';

export default VFlex;
